import { mapGetters } from 'vuex'
import ModalEditDevice from './components/ModalEditDevice'
import { StaffService } from '@/services/staff.service'
import { DeviceService } from '@/services/device.service'
import Config from '@/thirdParty/config'

export default {
  components: { ModalEditDevice },
  data() {
    return {
      showModalDevice: false,
      deviceData: null,
      deviceType: 'add',
      listDeviceDelete: [],
      statusPaymentOptions: Config.statusPaymentOptions,
      statusFileContractOptions: Config.statusFileContractOptions,
    }
  },
  methods: {
    // quyền
    // CNPS_SUR_PERF_KPI_FILE_VIEW,  Xem file upload ,  Xem file upload KPI
    // CNPS_SUR_PERF_KPI_FILE_UPLOAD ,  Upload file kpi ,  Tải lên file kpi
    // CNPS_SUR_PERF_KPI_FILE_CREATE ,  Tạo file kpi ,  Tạo kpi bằng file
    // CNPS_SUR_PERF_KPI_FILE_UPDATE ,  Update file kpi ,  Sửa kpi bằng file

    // CNPS_SUR_PERF_KPI_AGGREGATE_VIEW ,  Xem kpi ,  Xem kpi
    // CNPS_SUR_PERF_KPI_AGGREGATE_UPDATE ,  Update kpi ,  Sửa thông tin kpi
    // CNPS_SUR_PERF_KPI_AGGREGATE_SEND_APPROVE ,  Gửi duyệt kpi ,  Gửi duyệt kpi
    // CNPS_SUR_PERF_KPI_AGGREGATE_CANCEL ,  Hủy kpi ,  Hủy kpi
    // CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_APPROVE_REJECT ,  Kế toán duyệt/từ chối ,  Kế toán duyệt/từ chối
    // CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_ADDITIONAL ,  Kế toán yêu cầu bổ sung ,  Kế toán yêu cầu bổ sung
    // CNPS_SUR_PERF_KPI_AGGREGATE_SA_ADDITIONAL ,  SA bổ sung ,  SA bổ sung
    // CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT ,  Giám sát duyệt/từ chối ,  Giám sát duyệt/từ chối
    // CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_EXPLANATION ,  Giám sát yêu cầu giải trình ,  Giám sát yêu cầu giải trình
    // CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_SA_EXPLANATION ,  SA giải trình ,  SA giải trình
    // CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_FILE_APPROVE ,  Kế toán tải file duyệt ,  Kế toán tải file duyệt

    // gửi duyêt
    canDeviceKpiSendApproveMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_SEND_APPROVE')
    },
    async deviceKpiSendApproveMx(ids = []) {
      const check = this.canDeviceKpiSendApproveMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return false
      }
      const flags = await this.approveMx('bạn có chắn chắn muốn gửi duyệt')
      if (!flags) return
      try {
        this.showLoading = true
        const params = {
          ids,
        }
        const response = await DeviceService.deviceKpiSendApprove(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('Đã gửi duyệt thành công')
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // check
    async checkDeviceKpiPaymentInfo(device) {
      try {
        this.showLoading = true
        const params = {
          appendixCode: null,
          contractCode: null,
          emailSale: null,
          id: null,
          kpi: null,
          merchantEmail: null,
          month: null,
          note: null,
          serial: null,
          receiptCode: null, //
        }
        for (const property in params) {
          params[property] = device[property]
        }
        // console.log('check', params);
        // return false;
        const response = await DeviceService.checkDeviceKpiPaymentInfo(params)
        if (response.code === 1000) {
          return response.data
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    async checkDeviceKpiSellInfo(device) {
      try {
        this.showLoading = true
        const params = {
          appendixCode: null,
          contractCode: null,
          emailSale: null,
          id: null,
          kpi: null,
          merchantEmail: null,
          month: null,
          note: null,
          serial: null,
          service: null,
          receiptCode: null, //
        }
        for (const property in params) {
          params[property] = device[property]
        }
        // console.log('check', params);
        // return false;
        const response = await DeviceService.checkDeviceKpiSellInfo(params)
        if (response.code === 1000) {
          return response.data
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },

    // GS thao tac
    canMonitorAction() {
      return (
        this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT') ||
        this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_EXPLANATION')
      )
    },
    // update
    canDeviceKpiUpdateMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_UPDATE')
    },
    //  UPDATE,
    async deviceKpiUpdateMx(device) {
      if (!device) {
        console.log(device)
        this.showFailMx('Không đủ thông tin để tiếp tục')
        return false
      }
      const check = this.canDeviceKpiUpdateMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return false
      }
      // check UPDATE
      let checkKpi = null
      if (device.serviceType === 'PAYMENT') {
        checkKpi = await this.checkDeviceKpiPaymentInfo(device)
        if (!checkKpi) {
          return false
        }
      }
      if (device.serviceType === 'SELL') {
        checkKpi = await this.checkDeviceKpiSellInfo(device)
        if (!checkKpi) {
          return false
        }
      }
      const params = {
        action: null,
        appendixCode: null,
        appendixId: null,
        appendixStatus: null,
        categoryId: null,
        categoryName: null,
        contractCode: null,
        contractId: null,
        contractStatus: null,
        deviceId: null,
        duration: null,
        emailSale: null,
        formContract: null,
        id: null,
        idSale: null,
        kpi: null,
        statusHandover: null,
        merchantAddress: null,
        merchantEmail: null,
        merchantMobile: null,
        merchantName: null,
        month: null,
        note: null,
        packageType: null,
        payTime: null,
        paymentType: null,
        price: null,
        receiptCode: null,
        receiptId: null,
        receiptStatus: null,
        receiptTime: null,
        referSource: null,
        serial: null,
        service: null,
        superior: null,
        timeSign: null,
        transactionCode: null,
      }
      for (const property in params) {
        params[property] = device[property] ?? null
      }
      if (!checkKpi?.idSale) {
        console.log(checkKpi)
        this.showFailMx('Thiếu id Sale')
        return false
      }
      params.idSale = checkKpi.idSale
      params.statusHandover = checkKpi.statusHandover
      try {
        this.showLoading = true
        console.log('update', { params, checkKpi })
        const response = await DeviceService.deviceKpiUpdate(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },

    // hủy
    canDeviceKpiCancelMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_CANCEL')
    },
    async deviceKpiCancelMx(ids = []) {
      const check = this.canDeviceKpiCancelMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return false
      }

      const flag = await this.approveMx(`Bạn có chắc chắn muốn hủy KPI này`)
      if (!flag) return false
      try {
        this.showLoading = true
        const params = {
          ids,
        }
        console.log(33, params)
        const response = await DeviceService.deviceKpiCancel(params)
        if (response.code === 1000) {
          this.fetchData()
          this.showSuccessMx('Đã hủy KPI thành công')
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // kế toán từ chối
    canDeviceKpiAccountantRejectMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_APPROVE_REJECT')
    },
    async deviceKpiAccountantRejectMx(ids) {
      const check = this.canDeviceKpiAccountantRejectMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return
      }
      const { value: flag, note } = await this.rejectMx('Nhập lý do từ chối')
      if (!flag) return

      try {
        this.showLoading = true
        const params = {
          notes: [
            {
              id: ids[0],
              note,
            },
          ],
        }
        console.log(33, params)
        const response = await DeviceService.deviceKpiAccountantReject(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('Kế toàn từ chối thành công')
          this.fetchData()
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // kế toán xác nhận
    canDeviceKpiAccountantApproveMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_APPROVE_REJECT')
    },
    async deviceKpiAccountantApproveMx({ ids, note, statusFileContract, statusPayment }) {
      const check = this.canDeviceKpiAccountantApproveMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return false
      }
      try {
        this.showLoading = true
        const params = {
          kpiNotes: [
            {
              id: ids[0],
              note,
              statusFileContract,
              statusPayment,
            },
          ],
        }
        console.log('kế toán xác nhận', params)
        const response = await DeviceService.deviceKpiAccountantApprove(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },

    // kế toán bổ sung
    canDeviceKpiAccountantAdditionalMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_ACCOUNTANT_ADDITIONAL')
    },
    async deviceKpiAccountantAdditionalMx(ids) {
      const check = this.canDeviceKpiAccountantAdditionalMx()
      if (!check) {
        this.showLoading = false
        this.showFailMx('Không có quyền truy cập')
        return false
      }
      const { value: flag, note } = await this.rejectMx('Nhập lý do cần bổ sung')
      if (!flag) return

      try {
        this.showLoading = true
        const params = {
          notes: [
            {
              id: ids[0],
              note,
            },
          ],
        }
        console.log('kế toán bổ sung', params)
        const response = await DeviceService.deviceKpiAccountantAdditional(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('kế toán yêu cầu bổ sung thành công')
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // Admin bổ sung
    canDeviceKpiSAAdditionalMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_SA_ADDITIONAL')
    },
    async deviceKpiSAAdditionalMx(data) {
      const check = this.canDeviceKpiSAAdditionalMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return false
      }
      try {
        this.showLoading = true
        const params = {
          kpiNotes: [
            {
              id: data.id,
              note: data.note,
              transactionCode: data.transactionCode,
            },
          ],
        }
        console.log('Admin bổ sung', params)
        const response = await DeviceService.deviceKpiSAAdditional(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('Admin bổ sung thành công')
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },

    // GS từ chối
    canDeviceKpiMonitorRejectMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT')
    },
    async deviceKpiMonitorRejectMx(ids) {
      const check = this.canDeviceKpiMonitorRejectMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return
      }
      const { value: flag, note } = await this.rejectMx('Nhập lý do từ chối')
      if (!flag) return

      try {
        this.showLoading = true
        const params = {
          notes: [
            {
              id: ids[0],
              note,
            },
          ],
        }
        // console.log(33, params);
        const response = await DeviceService.deviceKpiMonitorReject(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('GS từ chối thành công')
          this.fetchData()
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // GS giải trình
    canDeviceKpiMonitorRequestExplanationMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_EXPLANATION')
    },
    async deviceKpiMonitorRequestExplanationMx(ids) {
      const check = this.canDeviceKpiMonitorRequestExplanationMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return
      }
      const { value: flag, note } = await this.rejectMx('Nhập lý do giải trình')
      if (!flag) return

      try {
        this.showLoading = true
        const params = {
          notes: [
            {
              id: ids[0],
              note,
            },
          ],
        }
        // console.log(33, params);
        const response = await DeviceService.deviceKpiMonitorRequestExplanation(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('GS yêu cầu giải trình thành công')
          this.fetchData()
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // GS duyệt
    canDeviceKpiMonitorApproveMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_APPROVE_REJECT')
    },
    async deviceKpiMonitorApproveMx(ids) {
      const check = this.canDeviceKpiMonitorApproveMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return
      }
      const flags = await this.approveMx('GS có chắn chắn muốn duyệt')
      if (!flags) return
      try {
        this.showLoading = true
        const params = {
          ids,
        }
        // console.log(33, params);
        const response = await DeviceService.deviceKpiMonitorApprove(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.showSuccessMx('GS duyệt thành công')
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
    // SA giải trình
    canDeviceKpiSAExplanationMx() {
      return this.dataPermission.includes('CNPS_SUR_PERF_KPI_AGGREGATE_MONITOR_SA_EXPLANATION')
    },
    async deviceKpiSAExplanationMx(data) {
      const check = this.canDeviceKpiSAExplanationMx()
      if (!check) {
        this.showFailMx('Không có quyền truy cập')
        return
      }
      try {
        this.showLoading = true
        const params = {
          kpiNotes: [
            {
              emailSale: data.emailSale,
              id: data.ids[0],
              kpi: data.kpi,
              month: data.month,
              note: data.note,
            },
          ],
        }
        console.log('SA giải trình', params)
        // return;
        const response = await DeviceService.deviceKpiSAExplanation(params)
        if (response.code === 1000) {
          this.showLoading = false
          this.fetchData()
          return true
        } else {
          throw new Error(response.message)
        }
      } catch (error) {
        console.log(error)
        this.showLoading = false
        this.showFailMx(error.message ?? error)
        return false
      } finally {
        this.showLoading = false
      }
    },
  },
  computed: {
    ...mapGetters({
      dataPermission: 'role/dataPermission',
    }),
  },
}

const dataUser = JSON.parse(localStorage.getItem('userData'))
let listUserFetch = []

export async function getListUserFn() {
  if (listUserFetch.length) {
    return listUserFetch
  }
  try {
    const res = await StaffService.getStaffByIdSuperior({
      userId: dataUser.userId,
    })
    const list =
      res.data?.map(s => ({
        id: s.userId,
        text: s.name + ' - ' + s.userName,
        userName: s.userName,
        name: s.name,
      })) ?? []
    listUserFetch = list
    return list
  } catch (error) {
    console.log(error)
    return []
  }
}

let listUserFetchByEmail = []
export async function getListUserFnByEmail() {
  if (listUserFetchByEmail.length) {
    return listUserFetchByEmail
  }
  try {
    const rawList = await getListUserFn()
    const list =
      rawList.map(s => ({
        id: s.userName,
        text: s.name + ' - ' + s.userName,
        userName: s.userName,
      })) ?? []
    listUserFetchByEmail = list
    return list
  } catch (error) {
    console.log(error)
    return []
  }
}
// export function findReasons (deviceKpiLogs, type) {
//   console.log(deviceKpiLogs, type);
//   if (!deviceKpiLogs || !type) {
//     return null
//   }
//   const lastItem = deviceKpiLogs.find( item => item.type === type)
//   console.log(lastItem.note);
//   return lastItem.note
// }
